import { render, staticRenderFns } from "./BusinessLocations.vue?vue&type=template&id=d8727ba0"
import script from "./BusinessLocations.vue?vue&type=script&lang=js"
export * from "./BusinessLocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports